export default function formattedCreditsWithHours(credit: number, shortVersion?: boolean): string {
  const minUnit = shortVersion ? 'm' : 'min'
  const secUnit = shortVersion ? 's' : 'sec'

  const hours = Math.floor(credit / 3600)
  if (hours > 0) {
    return `${hours} h ${Math.floor((credit - hours * 3600) / 60)} ${minUnit} ${Math.round(credit % 60)} ${secUnit}`
  } else {
    return `${Math.floor(credit / 60)} ${minUnit} ${Math.round(credit % 60)} ${secUnit}`
  }
}
